import React from 'react';

class Progress extends React.Component {

	render() {
        let { visible } = this.props;

        return (
            <div className='progress-overlay' style={{ display: visible ? 'block' : 'none'}}>
                <div className='spinner'>
                  <div className='dot1'></div>
                  <div className='dot2'></div>
                </div>
            </div>
        )
    }
}

export default Progress;



// WEBPACK FOOTER //
// ./source/components/progress.js